export default {
  data() {
    return {
      sexes: [
        {
          key: "Male",
          value: "message.sexMale"
        },
        {
          key: "Female",
          value: "message.sexFemale"
        }
      ]
    }
  },
  methods: {
    localizeSex(key) {
      let self = this;
      let localization = self.sexes.filter(function (item) {
        return item.key === key;
      });
      if(localization.length === 1) {
        return self.$t(localization[0].value);
      }
      else {
        return key
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/Genders/index.js